import { createAnimation } from '@ionic/vue';
import type { AnimationBuilder } from '@ionic/core';

// reason: any is used by ionic
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const smoothFadeAnimation: AnimationBuilder = (_: HTMLElement, opts?: any) => {
  const entering = createAnimation()
    .addElement(opts.enteringEl)
    .duration(200)
    .fromTo('opacity', 0, 1)
    .fromTo('transform', 'scale(0.98)', 'scale(1)');

  const leaving = createAnimation()
    .addElement(opts.leavingEl)
    .duration(200)
    .fromTo('opacity', 1, 0.95);

  return createAnimation()
    .easing('ease-in-out')
    .addAnimation([entering, leaving]);
};
